import { useCallback, useEffect, useRef, useState } from 'react'
import { useFocusEffect } from 'expo-router'
import { useStore } from '../../../models'

interface UseConnectToGameProps {
  isWebSocketConnected: boolean
  channelName: string | undefined
}

export const useConnectToGame = ({ isWebSocketConnected, channelName }: UseConnectToGameProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const {
    game: { isWalkthrough, setupGame, appState }
  } = useStore()

  useEffect(() => {
    if (isLoading && !isWalkthrough && appState === 'active') {
      setupGame()
    }
  }, [isLoading, setupGame, isWalkthrough, appState])

  useFocusEffect(
    useCallback(() => {
      const attemptToConnect = async () => {
        try {
          if (channelName && !isWebSocketConnected) {
            setIsLoading(true)
          } else {
            setIsLoading(false)
          }
        } catch (err) {
          console.error('useEffect', err)
        }
      }

      if (isWalkthrough) {
        setIsLoading(false)
      } else {
        attemptToConnect()
      }

      return () => {
        // teardown
        setIsLoading(false)
      }
    }, [isWebSocketConnected, channelName, isWalkthrough])
  )
  return {}
}
